import  { useState } from "react";

const Help = ({ title, message, items }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="help-div">
      <button
        className="btn-white me-3"
        onClick={() => setOpen((prev) => !prev)}
      >
        Help
      </button>

      {open && (
        <div className="help-wrapper">
          <div className="help-text">
            {title && <h2 className="help-page-title">{title}</h2>}
            {message && <p className="help-message">{message}</p>}

            {items?.length > 0 && (
              <ul className="help-page-lists">
                {items.map((item, index) => (
                  <li key={index} className="help-page-list">
                    {item}
                  </li>
                ))}
              </ul>
            )}
            <div className="clsbtngrp d-flex justify-content-end mt-3">
                <button className="btn-black" onClick={() => setOpen(false)}>Understood</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Help;
